import { Priority } from '../../types';

/**
 * Maps API priority numbers (1-4) to the frontend Priority enum.
 */
export const PRIORITY_MAP: { [key: number]: Priority } = {
  1: Priority.Critical,
  2: Priority.High,
  3: Priority.Medium,
  4: Priority.Low,
};

/**
 * Maps the frontend Priority enum back to API priority numbers.
 * This is used when sending updates to the API.
 */
export const REVERSE_PRIORITY_MAP: { [key in Priority]: number } = {
  [Priority.Critical]: 1,
  [Priority.High]: 2,
  [Priority.Medium]: 3,
  [Priority.Low]: 4,
};

/**
 * Safely converts a priority value from the API (which can be a string, number, or null)
 * into a `Priority` enum value. Defaults to 'Medium' if the API value is invalid or missing.
 * @param {string | number | null} apiPriority - The priority value received from the API.
 * @returns {Priority} The corresponding Priority enum member.
 */
export const getPriorityFromApi = (apiPriority: string | number | null): Priority => {
  // If priority is not provided, default to Medium.
  if (apiPriority === null || apiPriority === undefined) {
    return Priority.Medium;
  }
  // Convert string priorities (e.g., "1") to numbers.
  const priorityKey = typeof apiPriority === 'string' ? parseInt(apiPriority, 10) : apiPriority;
  // Look up the priority in the map, or default to Medium if not found.
  return PRIORITY_MAP[priorityKey] || Priority.Medium;
};
